
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chapters/popular",
      function () {
        return require("private-next-pages/chapters/popular.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chapters/popular"])
      });
    }
  